import {Distances, NumberOfRooms} from "../../enums/enums";

export enum FilterAnyLabels {
	BELIEBIG = "filter.beliebig",
	ALLE = "filter.alle"
}

const BathroomBedroomDropdownOptions = [
	FilterAnyLabels.BELIEBIG,
	NumberOfRooms.EIN_ZIMMER.label,
	NumberOfRooms.ZWEI_ZIMMER.label,
	NumberOfRooms.DREI_ZIMMER.label,
	NumberOfRooms.VIER_ZIMMER.label,
	NumberOfRooms.FUENF_ZIMMER.label
];
export const PropertyTypeQueryKey = "property_type[]";

export const Filter: {
	[key: string]: {
		label: string;
		queryKey: string;
		values?: string[];
	};
} = {
	BathroomsTotal: {
		label: "filter.bathroomsTotal",
		queryKey: "bathrooms_total",
		values: BathroomBedroomDropdownOptions
	},
	BedroomsTotal: {
		label: "filter.bedroomsTotal",
		queryKey: "bedrooms_total",
		values: BathroomBedroomDropdownOptions
	},
	Villa: {
		label: "filter.propertyType.villa",
		queryKey: PropertyTypeQueryKey,
		values: ["1"]
	},
	Studio: {
		label: "filter.propertyType.studio",
		queryKey: PropertyTypeQueryKey,
		values: ["2"]
	},
	LandHaus: {
		label: "filter.propertyType.countryHouse",
		queryKey: PropertyTypeQueryKey,
		values: ["3"]
	},
	Reihenhaus: {
		label: "filter.propertyType.terracedHouse",
		queryKey: PropertyTypeQueryKey,
		values: ["4"]
	},
	Appartment: {
		label: "filter.propertyType.appartment",
		queryKey: PropertyTypeQueryKey,
		values: ["6"]
	},
	Grundstueck: {
		label: "filter.propertyType.property",
		queryKey: PropertyTypeQueryKey,
		values: ["9"]
	},
	Hotel: {
		label: "filter.propertyType.hotel",
		queryKey: PropertyTypeQueryKey,
		values: ["10"]
	},
	Restaurant: {
		label: "filter.propertyType.restaurant",
		queryKey: PropertyTypeQueryKey,
		values: ["11", "21"]
	},
	Ladenlokal: {
		label: "filter.propertyType.shop",
		queryKey: PropertyTypeQueryKey,
		values: ["12"]
	},
	Lager: {
		label: "filter.propertyType.warehouse",
		queryKey: PropertyTypeQueryKey,
		values: ["13"]
	},
	Gewerbegrundstueck: {
		label: "filter.propertyType.commercialProperty",
		queryKey: PropertyTypeQueryKey,
		values: ["14"]
	},
	Anlegestelle: {
		label: "filter.propertyType.landing",
		queryKey: PropertyTypeQueryKey,
		values: ["15"]
	},
	GarageType: {
		label: "filter.propertyType.garage",
		queryKey: PropertyTypeQueryKey,
		values: ["16"]
	},
	Fischerhaus: {
		label: "filter.propertyType.fishermansHouse",
		queryKey: PropertyTypeQueryKey,
		values: ["17"]
	},
	Maisonette: {
		label: "filter.propertyType.maisonette",
		queryKey: PropertyTypeQueryKey,
		values: ["18"]
	},
	Penthouse: {
		label: "filter.propertyType.penthouse",
		queryKey: PropertyTypeQueryKey,
		values: ["19"]
	},
	Haus: {
		label: "filter.propertyType.house",
		queryKey: PropertyTypeQueryKey,
		values: ["20"]
	},
	Pool: {
		label: "filter.pool",
		queryKey: "pool"
	},
	Mooring: {label: "filter.mooring", queryKey: "mooring"},
	Internet: {label: "filter.internet", queryKey: "internet"},
	SAT_TV: {label: "filter.satTv", queryKey: "cable_sat_tv"},
	AirCondition: {label: "filter.airCondition", queryKey: "aircondition"},
	FencedYard: {label: "filter.fencedYard", queryKey: "fenced_yard"},
	Dishwasher: {label: "filter.dishwasher", queryKey: "dishwasher"},
	WashingMachine: {
		label: "filter.washingMachine",
		queryKey: "washing_machine"
	},
	Shutters: {label: "filter.shutters", queryKey: "shutters"},
	BBQ_Grill: {label: "filter.bbqGrill", queryKey: "bbq_grill"},
	Pets: {label: "filter.pets", queryKey: "pets"},
	Garage: {label: "filter.garage", queryKey: "garage"},
	City: {label: "filter.city", queryKey: "cities[]"},
	DistanceToSea: {
		label: "filter.distanceToSea",
		queryKey: "distance_to_sea",
		values: [
			FilterAnyLabels.BELIEBIG,
			Distances.FUENFZIG_M.label,
			Distances.FUENFZIG_BIS_HUNDERT_M.label,
			Distances.HUNDERT_BIS_FUENFHUNDERT_M.label,
			Distances.FUENFHUNDERT_BIS_EIN_KM.label,
			Distances.EIN_BIS_FUENF_KM.label,
			Distances.FUENF_BIS_ZEHN_KM.label,
			Distances.ZEHN_BIS_ZWANZIG.label
		]
	},
	DistanceToCenter: {
		label: "filter.distanceToCenter",
		queryKey: "distance_to_city_center",
		values: [
			FilterAnyLabels.BELIEBIG,
			Distances.FUENFZIG_M.label,
			Distances.FUENFZIG_BIS_HUNDERT_M.label,
			Distances.HUNDERT_BIS_FUENFHUNDERT_M.label,
			Distances.FUENFHUNDERT_BIS_EIN_KM.label,
			Distances.EIN_BIS_FUENF_KM.label,
			Distances.FUENF_BIS_ZEHN_KM.label,
			Distances.ZEHN_BIS_ZWANZIG.label
		]
	},
	DistanceToGolf: {
		label: "filter.distanceToGolf",
		queryKey: "distance_to_golf_course",
		values: [
			FilterAnyLabels.BELIEBIG,
			Distances.FUENFZIG_M.label,
			Distances.FUENFZIG_BIS_HUNDERT_M.label,
			Distances.HUNDERT_BIS_FUENFHUNDERT_M.label,
			Distances.FUENFHUNDERT_BIS_EIN_KM.label,
			Distances.EIN_BIS_FUENF_KM.label,
			Distances.FUENF_BIS_ZEHN_KM.label,
			Distances.ZEHN_BIS_ZWANZIG.label
		]
	},
	ViewSea: {
		label: "filter.viewSea",
		queryKey: "view_sea"
	},
	LivingArea: {
		label: "filter.livingArea",
		queryKey: "living_area_m2",
		values: [
			FilterAnyLabels.BELIEBIG,
			"min. 20 m²",
			"min. 50 m²",
			"min. 100 m²",
			"min. 150 m²",
			"min. 200 m²",
			"min. 300 m²",
			"min. 500 m²"
		]
	},
	PlotSize: {
		label: "filter.plotSize",
		queryKey: "plot_size",
		values: [
			FilterAnyLabels.BELIEBIG,
			"min. 20 m²",
			"min. 50 m²",
			"min. 100 m²",
			"min. 150 m²",
			"min. 200 m²",
			"min. 300 m²",
			"min. 500 m²"
		]
	},
	MinPrice: {
		label: "filter.minPrice",
		queryKey: "min_price"
	},
	MaxPrice: {
		label: "filter.maxPrice",
		queryKey: "max_price"
	},
	Rent: {
		label: "filter.rent",
		queryKey: "rent"
	},
	Sale: {
		label: "filter.sale",
		queryKey: "sale"
	},
	ViewCanal: {
		label: "filter.viewCanal",
		queryKey: "view_canal"
	},
	MooringBefore: {
		label: "filter.mooringBefore",
		queryKey: "mooring_before_behind"
	},
	NorthOrientation: {
		label: "filter.northOrientation",
		queryKey: "orientation[]",
		values: ["1", "2", "8"]
	},
	SouthOrientation: {
		label: "filter.southOrientation",
		queryKey: "orientation[]",
		values: ["4", "5", "6"]
	}
};
